function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.293.293L6 4.586 1.707.293.293 1.707 4.586 6 .293 10.293l1.414 1.414L6 7.414l4.293 4.293 1.414-1.414L7.414 6l4.293-4.293L10.293.293z",
  fill: "#0B0C0F"
});

var SvgCloseBanner = function SvgCloseBanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjI5MjggMC4yOTI5NjlMNS45OTk5NSA0LjU4NTg2TDEuNzA3MDYgMC4yOTI5NjlMMC4yOTI4NDcgMS43MDcxOEw0LjU4NTc0IDYuMDAwMDhMMC4yOTI4NDcgMTAuMjkzTDEuNzA3MDYgMTEuNzA3Mkw1Ljk5OTk1IDcuNDE0MjlMMTAuMjkyOCAxMS43MDcyTDExLjcwNzEgMTAuMjkzTDcuNDE0MTcgNi4wMDAwOEwxMS43MDcxIDEuNzA3MThMMTAuMjkyOCAwLjI5Mjk2OVoiIGZpbGw9IiMwQjBDMEYiLz4KPC9zdmc+Cg==";
export { SvgCloseBanner as ReactComponent };